// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-box-associate {
  border-bottom: 1px solid #ccc;
  width: 400px;
  padding-left: 10px;
}

.left-image {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.text-line {
  font-size: 12px;
  line-height: 1.2;
  color: #f5f5f5;
}

.type-counter {
  font-size: 8px;
}

.text-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--ion-color-primary-contrast);
}

.table-sm {
  width: 70%;
}

.main-container {
  padding-top: 40px;
  display: flex;
  width: 100%;
  height: calc(100% - 55px);
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-left: 10px;
  overflow: scroll;
}

.filter-environment {
  display: flex;
  margin-top: 10px;
  padding-left: 10px;
}

.tr-element {
  border-bottom: 1px solid rgba(0, 0, 0, 0.167);
}

.td-vertical {
  vertical-align: middle;
}

.button-associate {
  padding-left: 10px;
}

.add-remove-button {
  height: 28px;
  width: 28px;
  --padding-end: 0;
  --padding-start: 0;
  --box-shadow: 0;
}

.inline-container {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-direction: row;
  justify-content: space-between;
}

.list-environment {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.environment-associated {
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.td-center {
  text-align: center;
  vertical-align: middle;
}

.select-all {
  margin-left: 15px;
}

.colored-box {
  height: 45px;
  margin: 10px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  background-color: var(--ion-color-primary);
}

.icon-smart-component {
  color: var(--ion-color-primary-contrast);
}

@media (max-width: 1024px) {
  .text-line {
    font-size: 8px;
  }
}
.margin-label {
  margin-left: 10px;
}

.selected-box {
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.element-clickable,
::ng-deep ion-input.element-clickable .native-input {
  cursor: pointer;
}

ion-item.select-box {
  border: 1px solid #ccc;
  border-radius: 15px;
  width: 90%;
  --detail-icon-opacity: 0.6;
  --detail-icon-font-size: 12px;
  --background-hover: white;
  --ripple-color: white;
}
ion-item.select-box ion-input {
  --placeholder-opacity: 0.33;
  caret-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/associate-smart-component/associate-smart-component.component.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,wCAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,iBAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,6CAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;EACE;IACE,cAAA;EACF;AACF;AAEA;EACE,iBAAA;AAAF;;AAGA;EACE,YAAA;EACA,6BAAA;AAAF;;AAGA;;EAEE,eAAA;AAAF;;AAGA;EACE,sBAAA;EACA,mBAAA;EACA,UAAA;EACA,0BAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;AAAF;AAEE;EACE,2BAAA;EACA,wBAAA;AAAJ","sourcesContent":[".select-box-associate {\n  border-bottom: 1px solid #ccc;\n  width: 400px;\n  padding-left:10px;\n}\n\n.left-image {\n  width: 30px;\n  height: 30px;\n  margin-right: 10px;\n}\n\n.text-line {\n  font-size: 12px;\n  line-height: 1.2;\n  color: #f5f5f5;\n}\n\n.type-counter {\n  font-size: 8px;\n}\n\n.text-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: var(--ion-color-primary-contrast);\n}\n\n.table-sm {\n  width: 70%;\n}\n\n.main-container {\n  padding-top: 40px;\n  display: flex;\n  width: 100%;\n  height: calc(100% - 55px);\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  padding-left: 10px;\n  overflow: scroll;\n}\n\n.filter-environment {\n  display: flex;\n  margin-top: 10px;\n  padding-left: 10px;\n}\n\n.tr-element {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.167);\n}\n\n.td-vertical {\n  vertical-align: middle;\n}\n\n.button-associate {\n  padding-left: 10px;\n}\n\n.add-remove-button {\n  height: 28px;\n  width: 28px;\n  --padding-end: 0;\n  --padding-start: 0;\n  --box-shadow: 0;\n}\n\n.inline-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.list-environment {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.environment-associated {\n  height: 50px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.td-center {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.select-all {\n  margin-left: 15px;\n}\n\n.colored-box {\n  height: 45px;\n  margin: 10px;\n  border-radius: 15px;\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n  background-color: var(--ion-color-primary);\n}\n\n.icon-smart-component {\n  color: var(--ion-color-primary-contrast);\n}\n\n@media (max-width: 1024px) {\n  .text-line {\n    font-size: 8px;\n  }\n}\n\n.margin-label {\n  margin-left: 10px;\n}\n\n.selected-box {\n  opacity: 0.5;\n  transition: opacity 0.3s ease;\n}\n\n.element-clickable,\n::ng-deep ion-input.element-clickable .native-input {\n  cursor: pointer;\n}\n\nion-item.select-box {\n  border: 1px solid #ccc;\n  border-radius: 15px;\n  width: 90%;\n  --detail-icon-opacity: 0.6;\n  --detail-icon-font-size: 12px;\n  --background-hover: white;\n  --ripple-color: white;\n\n  ion-input {\n    --placeholder-opacity: 0.33;\n    caret-color: transparent;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
